import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="">
                <h1>Azure Consulting Services</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol delivers innovative business experiences on a secure
                  Microsoft Azure cloud infrastructure. Our Azure consulting
                  services enable faster product development and delivery for
                  businesses' internal and customer operations.
                </p>
                <ul>
                  <li>Secure Cloud Infrastructure</li>
                  <li>Faster Product Development</li>
                  <li>Improved Customer Operations</li>
                  <li>Innovative Business Experiences</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
